import { Button, Col, Modal, Radio, Row, Space, Typography } from "antd";
import React, { useState, useImperativeHandle, useEffect } from "react";
import { ReactComponent as WordSVG } from "assets/images/svg/word.svg";
import type { RadioChangeEvent } from "antd";
import { Notification } from "components/common";
import "./TreatmentTypeModal.scss";
import { residentialNurseService } from "api";

const TreatmentTypeModal = React.forwardRef((props: any, ref) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [listTDT, setListTDT] = useState([]);
  const [value, setValue] = useState<number>(null);
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));
  useEffect(() => {});
  const getList = async () => {
    try {
      let res = await residentialNurseService.getListTreatmentCatalog();
      const newData = res.map((item) => ({
        ...item,
        key: item.id,
      }));

      setListTDT(newData);
    } catch (error) {
      console.log("🚀 ~ getList ~ error:", error);
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách  mẫu tường trình phẫu thuật"
      );
    }
  };
  useEffect(() => {
    if (isModalOpen) {
      // getList();
    }
  }, [isModalOpen]);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setValue(null);
  };
  const onChange = async ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);
  };
  const handleConfirm = async () => {
    if (value !== null) {
      props.handleConfirm(value, listTDT);
      closeModal();
    } else {
      Notification("error", "Hãy chọn tờ điều trị trước!");
      return;
    }
  };
  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={"Chọn phiếu điều trị"}
      >
        <Row>
          <Radio.Group onChange={onChange} value={value}>
            <Space direction="vertical">
              <Radio value={0}>
                <Row className="radio-box">
                  <Col>
                    <WordSVG />
                  </Col>
                  <Col className="box-text">
                    <Typography.Text strong>Tờ điều trị mộng</Typography.Text>
                  </Col>
                </Row>
              </Radio>
              <Radio value={1}>
                <Row className="radio-box">
                  <Col>
                    <WordSVG />
                  </Col>
                  <Col className="box-text">
                    <Typography.Text strong>Tờ điều trị TTT</Typography.Text>
                  </Col>
                </Row>
              </Radio>
              <Radio value={2}>
                <Row className="radio-box">
                  <Col>
                    <WordSVG />
                  </Col>
                  <Col className="box-text">
                    <Typography.Text strong>Tờ điều trị khác</Typography.Text>
                  </Col>
                </Row>
              </Radio>
            </Space>
          </Radio.Group>
          <Row style={{ marginTop: "4px", gap: "4px" }} justify={"end"}>
            <Button type="primary" danger onClick={closeModal}>
              Huỷ
            </Button>
            <Button type="primary" onClick={handleConfirm}>
              Xác nhận
            </Button>
          </Row>
        </Row>
      </Modal>
    </div>
  );
});

export default TreatmentTypeModal;
